import {computed, inject} from '@angular/core';
import {signalStoreFeature, type, withComputed} from '@ngrx/signals';
import {ResourcesService} from '../../services/resources.service';
import {GameStoreState, MAX_ATTEMPTS_PER_QUESTION} from '../game-state.model';
import {GAME_DATA_GENERAL_DEFAULTS} from '../../models/game-data.model';

/**
 * Contributes the read-only game configuration, derived from the async
 * {@link ResourcesService} resources.
 */
export function withGameData() {
  return signalStoreFeature(
    type<{state: GameStoreState}>(),
    withComputed((_store, resources = inject(ResourcesService)) => ({
      maxAttemptsPerQuestion: computed(() => MAX_ATTEMPTS_PER_QUESTION),
      allQuestions: computed(() => resources.gameData.value()?.questions ?? []),
      randomQuestionsPerGame: computed(() => resources.gameData.value()?.general.randomQuestionsPerGame ?? GAME_DATA_GENERAL_DEFAULTS.randomQuestionsPerGame),
      possibleScores: computed(() => resources.gameData.value()?.general.possibleScores ?? GAME_DATA_GENERAL_DEFAULTS.possibleScores),
      hintReduction: computed(() => resources.gameData.value()?.general.hintReduction ?? GAME_DATA_GENERAL_DEFAULTS.hintReduction),
      gameUrl: computed(() => resources.gameData.value()?.general.gameUrl ?? GAME_DATA_GENERAL_DEFAULTS.gameUrl),
      startGameLayerId: computed(() => resources.gameData.value()?.general.startGameLayerId ?? GAME_DATA_GENERAL_DEFAULTS.startGameLayerId),
      highScoreTreshold: computed(() => resources.gameData.value()?.general.highScoreTreshold ?? GAME_DATA_GENERAL_DEFAULTS.highScoreTreshold),
      mediumScoreTreshold: computed(() => resources.gameData.value()?.general.mediumScoreTreshold ?? GAME_DATA_GENERAL_DEFAULTS.mediumScoreTreshold),
    }))
  );
}
